/**
 * Schreibt Text in die Zwischenablage und meldet, ob es geklappt hat.
 *
 * <p>Der Browser darf den Zugriff verweigern (fehlende Berechtigung, unsicherer Kontext);
 * das ist für die Aufrufer kein Fehler, sondern nur „nicht kopiert“. Deshalb wird nie
 * abgelehnt, sondern mit {@code false} aufgelöst.
 */
export async function copyText(text: string): Promise<boolean> {
  if (!navigator.clipboard) {
    return false;
  }
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
